import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input, Output, EventEmitter } from '@angular/core';
import AngularHelperService from '../../services/angular-helper.service';
import moment from 'moment';

@Component({
	standalone: true,
	selector: 'table-timeslots',
	templateUrl: './table-timeslots.component.html',
	imports: [ CommonModule, ArrayLimitToPipe, StartFromPipe, FormsModule ]
})
export class TableTimeslotsComponent implements OnInit, OnDestroy {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() timeslot: any;
	@Output() timeslotChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() timeslots: any;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.getPageSize();
		this.vm.currentPage = this.vm.currentPage || 0;
		
		this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize.ps', () => { this.getPageSize(); });
		
		var currentSelectedTimeslot = {};
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.timeslot && !this.angularHelperService.isEqual(this.vm.timeslot, currentSelectedTimeslot)) {
				this.handleTimeslotChange(this.vm.timeslot, currentSelectedTimeslot);
				currentSelectedTimeslot = Object.assign({}, this.vm.timeslot);
			}
		}, 500);
		
		this.vm.isSelected = this.isSelected;
		this.vm.selectSlot = this.selectSlot;
		this.vm.setNextPage = this.setNextPage;
		this.vm.setPreviousPage = this.setPreviousPage;
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		this.angularHelperService.element(this.angularHelperService.getWindow()).off('resize.ps');
	}
	
	handleTimeslotChange(nv, ov) {
		if (this.angularHelperService.equals(nv, {}) || !nv || !nv.startTime || !this.vm.timeslots) return;
		var index: any = this.vm.timeslots.findIndex((item) => { return item.date == moment(nv.startTime).format('D.MM'); });
		if (index < 1) return;
		this.vm.currentPage = Math.floor(index / this.vm.pageSize);
	}
	
	getPageSize() {
		var windowWidth: any = this.angularHelperService.getWindow().innerWidth;
		if (windowWidth < 912) {
			this.vm.pageSize = Math.min(3, this.vm.timeslots.length);
			this.vm.currentPage = Math.max(0, Math.min(Math.ceil(this.vm.timeslots.length / this.vm.pageSize) - 1, this.vm.currentPage));
			return;
		}
		if (windowWidth < 1092) {
			this.vm.pageSize = Math.min(4, this.vm.timeslots.length);
			this.vm.currentPage = Math.max(0, Math.min(Math.ceil(this.vm.timeslots.length / this.vm.pageSize) - 1, this.vm.currentPage));
			return;
		}
		this.vm.pageSize = Math.min(5, this.vm.timeslots.length);
		this.vm.currentPage = Math.max(0, Math.min(Math.ceil(this.vm.timeslots.length / this.vm.pageSize) - 1, this.vm.currentPage));
	}
	
	selectSlot(slot) {
		this.vm.timeslot = slot;
		this.timeslotChange.emit(this.vm.timeslot);
	}
	
	isSelected(slot) {
		return this.vm.timeslot
			&& moment(this.vm.timeslot.startTime).isSame(slot.startTime, 'minute')
			&& moment(this.vm.timeslot.endTime).isSame(slot.endTime, 'minute');
	}
	
	setPreviousPage() {
		if (this.vm.currentPage > 0) this.vm.currentPage--;
	}
	
	setNextPage() {
		if (this.vm.currentPage < Math.ceil(this.vm.timeslots.length / this.vm.pageSize) - 1) this.vm.currentPage++;
	}
	
}